import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
import { Delete, CloseOutlined } from "@material-ui/icons/";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";



const EditProduct = (props) => {
    const classes = useStyles();
    const [response, fetchData] = UseFetchData();
    const [deleteresponse, DeleteDeliveryChallandtlsData] = UseFetchData();
    const [Productresponse, FetchProduct] = UseFetchData();
    const [SalesOrderDtlsID, setSalesOrderDtlsID] = useState("");
    const [ModelCode, setModelCode] = useState("");
    const [ProductSKUID, setProductSKUID] = useState("");
    const [Seq, setSeq] = useState("");
    const [Description, setDescription] = useState('');
    const [id, setid] = useState('');
    const [SalesOrderNo, setSalesOrderNo] = useState("");
    const [ConversionRate, setConversionRate] = useState("");
    const [ConversionResponse, fetchConversion] = UseFetchData();
    const [Rate, setRate] = useState(0);
    const [RateINR, setRateINR] = useState(0);
    const [Quantity, setQuantity] = useState(0);
    const [Currency, setCurrency] = useState();
    const [DiscountPer, setDiscountPer] = useState();
    const [DiscountAmt, setDiscountAmt] = useState();
    const [Total, setTotal] = useState();
    const [TotalINR, setTotalINR] = useState(0);
    const [ImagePath, setImagePath] = useState('');
    const [Amount, setAmount] = useState(Rate * Quantity);

    const validationSchema = Yup.object({
        ModelCode: Yup.string().required("Required!"),
        Quantity: Yup.string().required("Required!"),
        Rate: Yup.string().required("Required!"),
    });

    const OnDelete = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("DeliveryChallanDtlsID", props.DeliveryChallanDtlsID);
        DeleteDeliveryChallandtlsData("DeliveryChallan/DeleteDeliveryChallanDtls", bodyFormData);
    };

    const GetConversionDate = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("QuotationID", props.QTID);
        fetchConversion("Quotation/ConversionData", bodyFormData);
    }



    useEffect(() => {
        if (deleteresponse.Response === true) {
            props.setOpen(false);
            props.getByIDData()
        } else if (deleteresponse.Response === false) {
            alert("Failed.");
        }
    }, [deleteresponse]);

    const onSubmit = () => {
        var bodyFormData = new FormData();
        debugger
        bodyFormData.append("DeliveryChallanDtlsID", props.DeliveryChallanDtlsID);
        bodyFormData.append("DeliveryChallanID", props.DCID);
        bodyFormData.append("Seq", Seq);
        bodyFormData.append("ModelCode", ModelCode);
        bodyFormData.append("SalesOrderDtlsID", SalesOrderDtlsID);
        bodyFormData.append("Description", Description);
        bodyFormData.append("ConvFactor", ConversionRate);
        bodyFormData.append("Quantity", Quantity);
        bodyFormData.append("Rate", Rate);
        bodyFormData.append("RateINR", RateINR);
        bodyFormData.append("TotalAmount", Total);
        bodyFormData.append("TotalAmountINR", TotalINR);
        fetchData("DeliveryChallan/AddProduct", bodyFormData);
    };

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.getByIDData()
        } else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            } else {
                alert("Failed.");
            }
        }
    }, [response]);

    const PopulateData = () => {
        var bodyFormData = new FormData();
        // debugger;
        bodyFormData.append("DeliveryChallanDtlsID", props.DeliveryChallanDtlsID);
        FetchProduct("DeliveryChallan/DeliveryChallanDtlsByID", bodyFormData);
    };

    useEffect(() => {
        // debugger;
        if (ConversionResponse !== undefined) {
            if (ConversionResponse["ConversionData"] !== undefined) {
                // debugger;
                setCurrency(ConversionResponse["ConversionData"][0]["Currency"]);
            }
        }
    }, [ConversionResponse]);

    useEffect(() => {
        GetConversionDate();
        PopulateData();
    }, []);

    useEffect(() => {
        // debugger;
        if (Productresponse.length > 0) {
            setModelCode(Productresponse[0].ModelCode);
            setSalesOrderDtlsID(Productresponse[0].SalesOrderDtlsID);
            setSalesOrderNo(Productresponse[0].SalesOrderNo);
            setSeq(Productresponse[0].Seq);
            setDescription(Productresponse[0].Description);
            setQuantity(Productresponse[0].Quantity);
            setRate(Productresponse[0].Rate);
            setRateINR(Productresponse[0].RateINR);
            setConversionRate(Productresponse[0].ConversionRate);
            setCurrency(Productresponse[0].Currency);
            setAmount(Productresponse[0].Amount);
            setImagePath(Productresponse[0].FilePath);
            setDiscountPer(Productresponse[0].DiscountPer);
            setDiscountAmt(Productresponse[0].DiscountAmt);
            setTotal(Productresponse[0].TotalAmount);
            setTotalINR(Productresponse[0].TotalAmountINR);
        }
    }, [Productresponse]);

    useEffect(() => {
        setAmount(Quantity * Rate);
        // debugger;
        setTotal((Quantity * Rate).toFixed(2));
        setTotalINR((Quantity * RateINR).toFixed(2));

    }, [Rate, RateINR, Quantity, Currency]);

    return (
        <div>
            <Formik
                initialValues={{
                    ModelCode: ModelCode,
                    SalesOrderDtlsID: SalesOrderDtlsID,
                    SalesOrderNo: SalesOrderNo,
                    Seq: Seq,
                    Description: Description,
                    Rate: Rate,
                    RateINR: RateINR,
                    Quantity: Quantity,
                    ConversionRate: ConversionRate,
                    Currency: Currency,
                    Total: Total,
                    TotalINR: TotalINR,
                    Amount: Amount,
                    DiscountPer: DiscountPer,
                    DiscountAmt: DiscountAmt,
                    Total: Total
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            {/* <Typography className={classes.headertext} noWrap>Add Product</Typography> */}
                            <Grid spacing={1} container direction="row">
                                <Grid spacing={1} item xs={8} container>
                                    <Grid item xs={6}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            label="Model Code"
                                            name="ModelCode"
                                            disabled
                                            onChange={(e) => setModelCode(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            label="Seq"
                                            name="Seq"
                                            onChange={(e) => setSeq(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="text"
                                            label="SalesOrderNo"
                                            name="SalesOrderNo"
                                            onChange={(e) => setSalesOrderNo(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid spacing={1} container direction="row">
                                        <Grid item xs={12}>
                                            <BiztranControlsFormik
                                                control="textarea"
                                                type="text"
                                                label="Description"
                                                name="Description"
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="row" spacing={2} marginTop={5}>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Quantity"
                                                name="Quantity"
                                                // disabled
                                                onChange={(e) => setQuantity(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="RateINR"
                                                name="RateINR"

                                                onChange={(e) => setRateINR(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="RateUSD"
                                                name="Rate"
                                                onChange={(e) => setRate(e.target.value)}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid container direction="row" spacing={2} marginTop={5}>
                                        <Grid item xs={6} md={1} sm={2} lg={2} xl={2} >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Currency"
                                                name="Currency"
                                                disabled
                                                onChange={(e) => setCurrency(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2}  >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="Total"
                                                name="Total"
                                                disabled
                                                onChange={(e) => setTotal(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} sm={4} lg={3} xl={2} >
                                            <BiztranControlsFormik
                                                control="input"
                                                type="text"
                                                label="TotalINR"
                                                name="TotalINR"
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={4}>
                                    <Card className={classes.root}>
                                        <CardActionArea onClick={() => { window.open(ImagePath); }}>
                                            <CardMedia
                                                component="img"
                                                //alt={FileName}
                                                height="230"
                                                image={ImagePath}
                                                title="Product"
                                            />
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={12}>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                            <BiztranControls.Button
                                                text="Update"
                                                type="submit"
                                                startIcon={<SaveIcon />}
                                            />
                                            <BiztranControls.Button
                                                text="Delete"
                                                onClick={() => {
                                                    OnDelete();
                                                }}
                                                startIcon={<Delete />}
                                            />
                                            <BiztranControls.Button
                                                text="CLOSE"
                                                startIcon={<CloseOutlined />}
                                                onClick={() => { props.setOpen(false); }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    headertext: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        marginTop: "-16px",
        marginBottom: "10px",
        marginLeft: "-24px",
        marginRight: "-24px",
        //   borderRadius: "1rem",
    },
    root: {
        height: '100%',
        width: '100%',
        paddingTop: '7%',
        //paddingTop: '56.25%', // 16:9
    },
}));

export default EditProduct;

